import { DxDataGrid, DxColumn, DxSelection } from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";
import { arClient } from "@/api/ar-client";

import {
  DistributionStatus,
  convertDistributionStatus,
} from "../ultils/status";
import SectionTransformTable from "../ultils/Section/SectionTransformTable.vue";
import DeleteDialog from "@core/components/delete-dialog/DeleteDialog.vue";
import ConfirmDialog from "@core/components/confirm-dialog/ConfirmDialog.vue";
import SideBarviewDetailsDis from "./components/SideBarviewDetailsDis.vue";
import FormItems from "../ultils/Form/FormItems.vue";

import SearchList from "../ultils/SearchList/SearchList.vue";
import EzTable from "../ultils/Table/EzTable.vue";
import _ from "lodash";
import { useFetch } from "../ultils/Hooks/useFetch.ts";
import { AR_DDA01, AR_RPD02 } from "@/api/constant.js";

export default {
  components: {
    FormItems,
    SearchList,
    "delete-dialog": DeleteDialog,
    DxDataGrid,
    EzTable,
    DxColumn,
    "confirm-dialog": ConfirmDialog,
    SideBarviewDetailsDis,
    SectionTransformTable,
  },
  setup() {
    const { fetchData: fetchDetailData, isError: isFetchDetailDataError } = useFetch(
      arClient.api_AR_RPD02,
      {
        loadingMessage: "ar_common_get_detail",
        showLoading: true,
        disableSuccessMessage: true,
      }
    );
    const { fetchData: deleteDistribution, isError: isDeleteError } = useFetch(
      arClient.api_AR_DDA01,
      {
        loadingMessage: "ar_common_deleting",
        showLoading: true,
      }
    );
    return { fetchDetailData, isFetchDetailDataError, deleteDistribution, isDeleteError };
  },
  data() {
    return {
      actions: [
        {
          apiCode:AR_RPD02,
          title: "ar_common_detail",
          icon: "eye",
        },
        {
         apiCode:AR_DDA01,
          danger: true,
          icon: "trash",
          title: "ar_common_delete",
        },
      ],

      loading: false,
      listAccountClient: [],
      searchVal: {},
      detailRowIndex: 0,
      distributionHistory: [],
      listData: [],

      isShowViewDetail: false,
      dataDetail: null,
    };
  },
  methods: {
    refetchData() {
      this.$refs["tableRef"].fetchData();
    },

  

    async removeItem(dataId) {
      const body = {
        ArDistribution: {
          Id: dataId,
        },
      };
      await this.deleteDistribution(body).then(async () => {
        if (!this.isDeleteError) {
          await this.refetchData();
          await this.getListClient_AR_RCL01();

          this.isShowViewDetail = false;
          /*    this.dataDetail = null; */
        }
      });
    },
    async viewDetailItem(rowInfo) {
      if (rowInfo.column && rowInfo.column.cellTemplate === "Action") {
        return;
      }
      const body = {
        ArDistribution: {
          Id: rowInfo.data.Id,
        },
      };
      await this.fetchDetailData(body).then((data) => {
        if (this.isFetchDetailDataError) {
          return;
        }

        this.detailRowIndex = rowInfo.rowIndex;
        this.isShowViewDetail = true;
        this.dataDetail = data;
      });
    },
  },
  computed: {
    formItems() {
      return [
        {
          type: "string",
          name: "DistributionCode",
          label: "ar_client_distribution_code",
          placeholder: "ar_client_distribution_code",
          wrapperClass: "col-2",
        },
        {
          type: "string",
          name: "AccountCode",

          label: "ar_client_debit_account_code",
          placeholder: "ar_client_debit_account_code",
          wrapperClass: "col-2",
        },
        {
          type: "string",
          name: "ArPaymentCode",

          label: "ar_client_payment_code",
          placeholder: "ar_client_payment_code",
          wrapperClass: "col-2",
        },

        {
          type: "select",
          name: "ArTravelAgentId",
          dataSource: this.arClient.api_AR_RCL01,
          multiple: true,
          dataSourceParams: {
            IsCheckPermission: false,
          },
          customOptions: (options) =>
            options.map((option) => ({
              ...option,
              CodeName: `${option.TravelAgentCode} - ${option.NameVi}`,
            })),
          labelOption: "CodeName",
          label: "ar_client_company",
          placeholder: "ar_client_company",
          wrapperClass: "col-3",
        },
      
        {
          type: "select",
          name: "Status",
          dataSource: DistributionStatus.map((i) => ({ ...i, title: this.$t(i.title) })),
          multiple: true,
          customReduce: "value",
          labelOption: "title",
  
          label: "ar_client_status",
          wrapperClass: "col-3",
        },
        {
          type: "date",
          rangeData: ["FromDate", "ToDate"],
          name: "createdDate",
          isRange: true,
          placeholder: "ar_client_distribution_date",
          label: "ar_client_distribution_date",
          wrapperClass: "col-3",
        },
      ];
    },

    columns() {
    
      return [
        {
          caption: this.$t("ar_client_distribution_code"),
          field: "DistributionCode",
          minWidth:"130px"
        },
        {
          caption: this.$t("ar_common_company_code"),
          field: "TravelAgentCode",
          minWidth:"130px"
        },

        {
          caption: this.$t("ar_client_company"),
          field: "TravelAgentName",
          minWidth:"160px"
        },

        {
          caption: this.$t("ar_client_distribution_type"),
          cellTemplate:true,
          field: "DistributionType",
          align:"center",
          cellRender(data) {
            return data.data.DistributionType == "AUTO" ? "Tự động" : "Thủ công";
          },
          minWidth: "90px"
        },

        {
          caption: this.$t("ar_client_debit_account_code"),
          field: "ArAccountCode",
          minWidth:"130px"
        },
        {
          caption: this.$t("ar_clinent_total_amount_distributed"),
          field: "TotalAmount",
          cellTemplate: true,
          formatType: "currency",
          width: "140px",
        },
        {
          caption: this.$t("ar_client_bill_code"),
          field: "ArPaymentCode",
          minWidth:"130px"
        },
        {
          caption: this.$t("ar_client_status"),
          field: "Status",
          minWidth:"130px",
          cellTemplate:true,
          formatType:"text-variant",
          renderTextVariant:convertDistributionStatus
        },
        {
          caption: this.$t("ar_client_distribution_date"),
          field: "CreatedDate",
          minWidth: "120px",
          cellTemplate: true,
          formatType: "date",
        },
      ];
    },
  },
  
};
